export enum RequiredSkuType {
	ISLAND_BASE = 'ISLAND_BASE',
	COUNTERTOP = 'COUNTERTOP',
	COUNTERTOP_GRANITE = 'COUNTERTOP_GRANITE',
	COUNTERTOP_CONCRETE = 'COUNTERTOP_CONCRETE',
	APPLIANCE = 'APPLIANCE',
	ACCESSORY = 'ACCESSORY',
	BACKSPLASH = 'BACKSPLASH'
}
